import { INITIAL_LOC_CODE } from "config/config";
import getForm from "./form";

const {
  formField: { country, startPeriodYear, lastPeriodYear, periodYearStep },
} = getForm();

export const getInitialValues = (locCode?: number): any => {
  return {
    [country.name]: locCode ?? INITIAL_LOC_CODE,
    [startPeriodYear.name]: 1900,
    [lastPeriodYear.name]: 2049,
    [periodYearStep.name]: 10,
  };
};
